export default {"src":"/_next/static/media/icone-helio.03d9a9cc.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};